import { useEffect, useState } from "react";
import AdminNotesComponent from "../../components/applicationComponents/administrativeNotes/administrativeNotesComponent";
import ApplicationTypeComponent from "../../components/applicationComponents/applicationType/ApplicationTypeComponent";
import AssignAssessorComponent from "../../components/applicationComponents/assignAssessor/AssignAssessorComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import AssignStatusComponent from "../../components/applicationComponents/assignStatus/AssignStatusComponent";
import ContextOfChildComponent from "../../components/applicationComponents/contextOfChild/ContextOfChildComponent";
import SupportRequestedComponent from "../../components/applicationComponents/supportRequested/SupportRequestedComponent";
import GroupInformationComponent from "../../components/applicationComponents/groupInformation/groupInformationComponent";
import ChildComponent from "../../components/applicationComponents/child/ChildComponent";
import ProvidingInclusiveKindergartenEnvironmentComponent from "../../components/applicationComponents/providingInclusiveKindergartenEnvironment/ProvidingInclusiveKindergartenEnvironmentComponent";
import KindergartenComponent from "../../components/applicationComponents/kindergartenComponent/KindergartenComponent";
import ChildAttendanceComponent from "../../components/applicationComponents/childAttendance/ChildAttendanceComponent";
import ScreeningQuestionsComponent from "../../components/applicationComponents/screeningQuestions/ScreeningQuestionsComponent";
import ApplicationCreationComponent from "../../components/applicationComponents/applicationCreation/ApplicationCreationComponent";
import SubmitInitialApplicationComponent from "../../components/applicationComponents/submitInitialApplication/SubmitInitialApplicationComponent";
import SupportTypeComponent from "../../components/applicationComponents/supportType/supportType";
import AuthorisedRepresentativeComponent from "../../components/applicationComponents/authorisedRepresentative/AuthorisedRepresentativeComponent";
import SupportingDocumentsComponent from "../../components/applicationComponents/supportingDocuments/SupportingDocumentsComponent";
import ApplicationChecklistComponent from "../../components/applicationComponents/applicationChecklist/ApplicationChecklistComponent";
import GroupSupportNeedsComponent from "../../components/applicationComponents/legacy/groupSupportNeeds/GroupSupportNeedsComponent";
import ContextOfChildComponentLegacy from "../../components/applicationComponents/legacy/contextOfChild/ContextOfChildComponentLegacy";
import AppealOutcomeComponent from "../../components/applicationComponents/appealOutcome/AppealOutcomeComponent";
import AppealRequestComponent from "../../components/applicationComponents/appealRequest/AppealRequestComponent";
import ApplicationOutcomeComponent from "../../components/applicationComponents/applicationOutcome/applicationOutcomeComponent";

export default function ApplicationView() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText, id, applicationBase, rehydrate } = useApplicationContext();

  useEffect(() => {
    setHeaderText({
      value: "View Application",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
    rehydrate().then(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-col align-items-start w-full height-calc">
          <ScreeningQuestionsComponent disabled={true} data={applicationBase.screeningQuestions} />
          <ApplicationCreationComponent disabled={true} />
          <SupportRequestedComponent disabled={true} data={applicationBase.supportRequested} />
          <KindergartenComponent disabled={true} data={applicationBase.kindergarten} />
          <GroupInformationComponent disabled={true} data={applicationBase.groupInformation} />
          <ProvidingInclusiveKindergartenEnvironmentComponent disabled={true} data={applicationBase.providingInclusiveKindergartenEnvironment} />
          <ChildComponent disabled={true} data={applicationBase.child} />
          <ChildAttendanceComponent disabled={true} data={applicationBase.childAttendance} />
          <ContextOfChildComponent disabled={true} data={applicationBase.contextOfChild} />
          <SupportingDocumentsComponent disabled={true} data={applicationBase.supportingDocuments} />
          {applicationBase.canKindergartenEdit && <SubmitInitialApplicationComponent disabled={true} />}
          <AuthorisedRepresentativeComponent />
          <ApplicationTypeComponent disabled={true} data={applicationBase.applicationType} />
          {applicationBase.applicationChecklists ? (
            applicationBase.applicationChecklists.checklists.map((data: any, index: number) => {
              return <ApplicationChecklistComponent key={index} index={index} disabled={true} data={data} />;
            })
          ) : (
            <ApplicationChecklistComponent index={0} disabled={true} data={{}} applicationId={id} />
          )}
          <AdminNotesComponent disabled={true} data={applicationBase.administrativeNote} />
          <AssignStatusComponent disabled={true} data={applicationBase.assignStatus} />
          <AssignAssessorComponent disabled={true} data={applicationBase.assignAssessor ?? {}} />
          <GroupSupportNeedsComponent disabled={true} data={applicationBase.groupSupportNeeds} />
          <ContextOfChildComponentLegacy disabled={true} data={applicationBase.contextOfChildLegacy} />
          <SupportTypeComponent disabled={true} data={applicationBase.supportType} />
          <ApplicationOutcomeComponent disabled={true} data={applicationBase.applicationOutcome} />
          <AppealRequestComponent disabled={true} data={applicationBase.appealRequest} />
          <AppealOutcomeComponent disabled={true} data={applicationBase.appealOutcome} />
          {/* <TransferRequestComponent disabled={true} data={applicationBase.transferRequest} /> */}
        </div>
      )}
    </div>
  );
}
